import React from 'react';
import {
  LayoutDashboard,
  Folder,
  Bug,
  Clock,
  BarChart,
  Users,
  Settings,
  Plus,
  KanbanSquare,
} from "lucide-react";
import { useAuth } from "../../context/AuthContext";

interface SidebarItemProps {
  icon: React.ReactNode;
  label: string;
  active?: boolean;
  onClick: () => void;
}

function SidebarItem({ icon, label, active, onClick }: SidebarItemProps) {
  return (
    <div
      onClick={onClick}
      className={`flex items-center gap-3 px-3 py-2 rounded-md cursor-pointer
      ${active ? "bg-green-100 text-green-700 font-medium" : "text-gray-700 hover:bg-gray-100"}`}
    >
      {icon}
      {label}
    </div>
  );
}

interface JiraSidebarProps {
  activeItem?: string;
}

export default function JiraSidebar({ activeItem }: JiraSidebarProps) {
  const { user } = useAuth();
  const isAdminOrPM = user?.role === 'admin' || user?.role === 'hr' || user?.role === 'product_manager' || user?.role === 'scrum_master';

  const setHash = (hash: string) => {
    window.location.hash = hash;
  };

  return (
    <aside className="w-64 bg-white border-r px-4 py-5 h-screen sticky top-0 overflow-y-auto">
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-green-600 px-3">
          Infotech
        </h2>
      </div>

      {isAdminOrPM && (
        <button className="w-full flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white py-2 rounded-md font-medium mb-6">
          <Plus size={16} /> Create Issue
        </button>
      )}

      <div className="space-y-1 text-sm">
        <SidebarItem
          icon={<LayoutDashboard size={16} />}
          label="Main Dashboard"
          active={activeItem === 'dashboard'}
          onClick={() => setHash("dashboard")}
        />

        {isAdminOrPM && (
          <>
            <SidebarItem
              icon={<LayoutDashboard size={16} />}
              label="Jira Dashboard"
              active={activeItem === 'jira'}
              onClick={() => setHash("jira")}
            />
            <SidebarItem
              icon={<Folder size={16} />}
              label="Projects"
              active={activeItem === 'projects'}
              onClick={() => setHash("projects")}
            />
          </>
        )}

        <SidebarItem
          icon={<KanbanSquare size={16} />}
          label="Board"
          active={activeItem === 'board'}
          onClick={() => setHash("board")}
        />

        {isAdminOrPM && (
          <>
            <SidebarItem
              icon={<Bug size={16} />}
              label="My Issues"
              active={activeItem === 'issues'}
              onClick={() => setHash("issues")}
            />
            <SidebarItem
              icon={<Clock size={16} />}
              label="Time Tracking"
              active={activeItem === 'time'}
              onClick={() => setHash("time")}
            />
            <SidebarItem
              icon={<BarChart size={16} />}
              label="Reports"
              active={activeItem === 'reports'}
              onClick={() => setHash("reports")}
            />
            <SidebarItem
              icon={<Users size={16} />}
              label="Team"
              active={activeItem === 'team'}
              onClick={() => setHash("team")}
            />
            <SidebarItem
              icon={<Settings size={16} />}
              label="Settings"
              active={activeItem === 'settings'}
              onClick={() => setHash("settings")}
            />
          </>
        )}
      </div>

      {isAdminOrPM && (
        <div className="mt-8 text-xs text-gray-400 px-3">
          <p className="mb-2">RECENT PROJECTS</p>
          <p>WEB Website Redesign</p>
          <p>MOB Mobile App</p>
          <p>CRM CRM Enhancement</p>
        </div>
      )}
    </aside>
  );
}
